import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { ShiptoDepositCrudSchema } from '@diamond/shared/schema/shipto-deposit';
import { apiInstance } from '@diamond/shared/utils';

const BASE_PATH = ShiptoDepositCrudSchema.path;

export const SHIPTO_DEPOSIT_DEFAULT_HISTORY_SIZE = 50;

export async function getShiptoDepositBalance(
  token: string,
  warehouse: string
): Promise<ShiptoDepositCrud['getBalance']['response']> {
  const { data } = await apiInstance(token).get<
    ShiptoDepositCrud['getBalance']['response']
  >(`${BASE_PATH}/balance`, {
    params: { warehouse },
  });
  return data;
}

export async function getShiptoDepositTransactionHistories(
  token: string,
  warehouse: string,
  page = 1,
  size = SHIPTO_DEPOSIT_DEFAULT_HISTORY_SIZE
): Promise<ShiptoDepositCrud['getTransactionHistories']['response']> {
  const { data } = await apiInstance(token).get<
    ShiptoDepositCrud['getTransactionHistories']['response']
  >(`${BASE_PATH}/transaction-histories`, {
    params: { warehouse, page, size },
  });
  return data;
}
